import { DISPUTE_FORM_FIELDS, DISPUTE_FORM_FIELDS_NAMES } from './dispute-form';
import { InputType } from '../../components/form/form-input-constants';

export const DisputeInputs = (cardTypes, managerSystemsTypes, disputeTypes): any[] => [
	{
		key: DISPUTE_FORM_FIELDS.DISPUTE_TYPE,
		fieldName: DISPUTE_FORM_FIELDS.DISPUTE_TYPE,
		label: DISPUTE_FORM_FIELDS_NAMES.DISPUTE_TYPE,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.DISPUTE_TYPE,
		inputType: InputType.Select,
		data: disputeTypes,
		placement: 'bottomEnd',
	},
	{
		key: DISPUTE_FORM_FIELDS.TRANSACTION_ID,
		fieldName: DISPUTE_FORM_FIELDS.TRANSACTION_ID,
		label: DISPUTE_FORM_FIELDS_NAMES.TRANSACTION_ID,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.TRANSACTION_ID,
		inputType: InputType.Text,
	},
	{
		key: DISPUTE_FORM_FIELDS.REQUEST_DATE,
		fieldName: DISPUTE_FORM_FIELDS.REQUEST_DATE,
		label: DISPUTE_FORM_FIELDS_NAMES.REQUEST_DATE,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.REQUEST_DATE,
		inputType: InputType.Date
	},
	{
		key: DISPUTE_FORM_FIELDS.CARD_TYPE,
		fieldName: DISPUTE_FORM_FIELDS.CARD_TYPE,
		label: DISPUTE_FORM_FIELDS_NAMES.CARD_TYPE,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.CARD_TYPE,
		inputType: InputType.Select,
		data: cardTypes,
		searchable: false,
	},
	{
		key: DISPUTE_FORM_FIELDS.BIN,
		fieldName: DISPUTE_FORM_FIELDS.BIN,
		label: DISPUTE_FORM_FIELDS_NAMES.BIN,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.BIN,
		inputType: InputType.Number
	},
	{
		key: DISPUTE_FORM_FIELDS.LAST_4,
		fieldName: DISPUTE_FORM_FIELDS.LAST_4,
		label: DISPUTE_FORM_FIELDS_NAMES.LAST_4,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.LAST_4,
		inputType: InputType.Number
	},
	{
		key: DISPUTE_FORM_FIELDS.CASE,
		fieldName: DISPUTE_FORM_FIELDS.CASE,
		label: DISPUTE_FORM_FIELDS_NAMES.CASE,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.CASE,
		inputType: InputType.Text
	},
	{
		key: DISPUTE_FORM_FIELDS.MANAGER_SYSTEM,
		fieldName: DISPUTE_FORM_FIELDS.MANAGER_SYSTEM,
		label: DISPUTE_FORM_FIELDS_NAMES.MANAGER_SYSTEM,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.MANAGER_SYSTEM,
		inputType: InputType.Select,
		data: managerSystemsTypes,
		searchable: false
	},
	{
		key: DISPUTE_FORM_FIELDS.DESCRIPTOR,
		fieldName: DISPUTE_FORM_FIELDS.DESCRIPTOR,
		label: DISPUTE_FORM_FIELDS_NAMES.DESCRIPTOR,
		placeholder: DISPUTE_FORM_FIELDS_NAMES.DESCRIPTOR,
		inputType: InputType.Text
	},
	{
		key: DISPUTE_FORM_FIELDS.IS_REFUND,
		checkboxFieldName: DISPUTE_FORM_FIELDS.IS_REFUND,
		label: DISPUTE_FORM_FIELDS_NAMES.IS_REFUND,
		inputType: 'checkbox',
		additionalClass: 'pt-4'
	},
];
